import React from 'react';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  Stack,
  Button,
} from '@mui/material';
import {
  Timeline as TimelineIcon,
  LocalFireDepartment as StreakIcon,
  Add as AddIcon,
  EmojiEvents as TrophyIcon,
} from '@mui/icons-material';
import { useStudy } from '../../contexts/StudyContext';
import { useNavigate } from 'react-router-dom';

const QuickStats = () => {
  const { studyData } = useStudy();
  const navigate = useNavigate();

  // Calculate average score from the last 10 tests
  const calculateAverageScore = () => {
    if (!studyData?.ptScores || studyData.ptScores.length === 0) return 0;
    const recentScores = studyData.ptScores.slice(-10);
    const sum = recentScores.reduce((acc, score) => acc + score.total, 0);
    return Math.round(sum / recentScores.length);
  };

  // Get the best PT score
  const getBestScore = () => {
    if (!studyData?.ptScores || studyData.ptScores.length === 0) return 0;
    return Math.max(...studyData.ptScores.map(score => score.total));
  };

  const stats = [
    {
      title: 'Current Streak',
      value: studyData?.streakData?.currentStreak || 0,
      icon: <StreakIcon sx={{ color: '#FF8042' }} />,
      unit: 'days'
    },

  ];

  return (
    <Card>
      <CardContent>
        <Grid container spacing={4}>
          {stats.map((stat, index) => (
            <Grid item xs={12} sm={4} key={index}>
              <Box
                sx={{
                  p: 2,
                  borderRadius: 2,
                  bgcolor: 'rgba(0, 0, 0, 0.02)',
                  height: '100%',
                }}
              >
                <Stack spacing={1}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {stat.icon}
                    <Typography variant="subtitle2" color="text.secondary">
                      {stat.title}
                    </Typography>
                  </Box>
                  <Typography variant="h4">
                    {stat.value}{stat.unit}
                  </Typography>
                </Stack>
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default QuickStats; 